import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';

import RTLLayout from 'layouts/rtl';
import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import 'assets/css/Plugins.css';
import Access from 'layouts/access';
import Scanner from 'views/stock/scanner';
import Hotjar from '@hotjar/browser';
import CommandPage from 'views/admin/main/ecommerce/commandPage';
import OrderSuccess from 'views/admin/main/ecommerce/commandPage/components/OrderSuccess';
import UiKit from 'views/ui-kit';
import ScrollToTop from 'components/router/scrollToTop';
import Delivery from 'views/external/delivery';
import ListDeliveries from 'views/delivery/listDeliveries';
import EditDeliveries from 'views/delivery/editDeliveries';
import AutoOrderAccount from 'views/external/auto-orders/account';
import PrintDelivery from 'views/delivery/editDeliveries/printDelivery';
import CommingSoon from 'views/comming-soon';
import PrintBLDelivery from 'views/delivery/printDeliveryBL/printBLDelivery';
import PrintTourRoadmap from 'views/delivery/printDeliveryBL/printTourRoadmap';
import MultiPortal from 'views/admin/main/ecommerce/commandPage/MultiPortal';
import PrintOrderSummary from 'views/orders/printSummary';
import PurchasePageSupplier from 'views/purchases/components/purchasePageSupplier';
import OfflineBanner from 'components/OfflineBanner';
import ConflictModal from 'components/ConflictModal';
import { useSyncEvents } from 'hooks/useSyncEvents';
import { usePrefetchOfflineData } from 'hooks/usePrefetchOfflineData';

Hotjar.init(3583940, 6);
const isMaintenance = false;


const App = () => {
    const [searchParams] = useSearchParams();
    const forceShopMode = searchParams.get('force_shop') === 'true';
    const { conflicts, resolveKeepLocal, resolveKeepServer } = useSyncEvents();
    usePrefetchOfflineData();

    const host = window.location.hostname.split(".");
    const subdomain = host[0];
    const isShopDomain = subdomain === 'shop' || window.location.hostname === 'shop.toola.fr' || forceShopMode;
    return (
        <div>
            <OfflineBanner />
            <ConflictModal
                conflicts={conflicts}
                resolveKeepLocal={resolveKeepLocal}
                resolveKeepServer={resolveKeepServer}
            />
            {isMaintenance && <CommingSoon />}
            {!isMaintenance && <ScrollToTop />}
            {!isMaintenance && (
                <Routes>
                    {/* Shop subdomain - Only ordering pages */}
                    {isShopDomain ? (
                        <>
                            <Route path="/" element={<CommandPage />} />
                            <Route path="/command" element={<CommandPage />} />
                            <Route path="/command/account" element={<AutoOrderAccount />} />
                            <Route path="/command/success" element={<OrderSuccess />} />
                            <Route path="/command/:v" element={<CommandPage />} />
                            <Route path="/portal/:v" element={<MultiPortal />} />
                            <Route path="/portal/" element={<MultiPortal />} />
                            {/* Redirect any other path to command page */}
                            <Route path="*" element={<Navigate to="/command" replace />} />
                        </>
                    ) : (
                <>
                    {/* Redirect all trafic to maintenance page */}
                    {/* Internal application */}
                    <Route path="auth/*" element={<AuthLayout />} />
                    <Route path="admin/*" element={<AdminLayout />} />
                    <Route path="/*" element={<AdminLayout />} />
                    <Route path="rtl/*" element={<RTLLayout />} />
                    <Route path="/" element={<Access />} />

                    {/* Delivery pages */}
                    <Route path="/delivery-ext/login" element={<Delivery />} />
                    <Route
                        path="/delivery-ext/login/:id"
                        element={<Delivery />}
                    />
                    <Route
                        path="/delivery-ext"
                        element={<ListDeliveries isExternalPage={true} />}
                    />
                    <Route
                        path="/delivery-ext/:date/:deliveryId"
                        element={<EditDeliveries isExternalPage={true} />}
                    />
                    <Route
                        path="/delivery-print/:date/:deliveryId"
                        element={<PrintDelivery isExternalPage={false} />}
                    />

                    {/* Close to delivery-print, but using BL design and data */}
                    <Route
                        path="/delivery-bl-print/:date/:deliveryId"
                        element={<PrintBLDelivery isExternalPage={false} />}
                    />

                    {/* Feuille de route tableau */}
                    <Route
                        path="/delivery-tour-roadmap/:date/:deliveryId"
                        element={<PrintTourRoadmap isExternalPage={false} />}
                    />

                    <Route
                        path="/print-order-summary"
                        element={<PrintOrderSummary />}
                    />

                    <Route
                        path="view-purchase/:token"
                        element={<PurchasePageSupplier />}
                    />

                    {/* Prototype */}
                    <Route path="/scanner" element={<Scanner />} />

                    {/* Dev */}
                    <Route path="ui-kit/" element={<UiKit />} />
                </>
                    )}
                </Routes>
            )}
        </div>
    );
};

export default App;
